<template>
  <div class="basic-message">
    <div :class="{'basic-message__glow': editMode}">
      <div
        @click="turnOnEditMode(val.uuid)"
        v-show="!editMode"
        class="basic-message__text"
      >{{ val.message.text[$store.state.flowEditorLocale] }}</div>
      <textarea-autosize
        class="basic-message__textarea"
        @blur.native="turnOffEditMode(val.uuid)"
        v-show="editMode"
        v-model="editedText"
        ref="textarea"
        maxlength="640"
      ></textarea-autosize>
    </div>
    <div class="basic-message__buttons">
      <message-button
        v-for="(button, n) in val.message.buttons"
        :key="button.uuid"
        :data="button"
        :n="n"
        @change="buttonChange($event, button.uuid, val.uuid)"
        @delete="buttonChange($event, button.uuid, val.uuid, true)"
      ></message-button>
      <div
        class="basic-message__create-button"
        @click="addButton()"
        v-if="val.message.buttons.length < 3"
      >
        <fai icon="plus"></fai>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'blockId'],
  data () {
    return {
      val: null,
      editMode: false,
      editedText: '',
      default: {
        button: {
          text: {},
          action: 'redirect',
          data: {
            target: null,
            passVariables: false,
            variables: {}
          }
        }
      }
    }
  },
  created () {
    this.val = this.value
    for (let locale in this.$store.state.flowLocales) {
      this.default.button.text[locale] = 'New button'
    }
  },
  methods: {
    addButton () {
      const i = this.val.message.buttons.length
      let el = JSON.parse(JSON.stringify(this.default.button))
      el.uuid = this.uid()
      this.$set(this.val.message.buttons, i, el)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
      this.$emit('input', this.val)
    },

    buttonChange (changed, uuid, stepUuid, del) {
      for (let i in this.val.message.buttons) {
        if (this.val.message.buttons[i].uuid !== uuid) continue
        if (!del) this.$set(this.val.message.buttons, i, changed)
        else this.$delete(this.val.message.buttons, i)
        this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
        this.$store.commit('SET_EDITED', true)
        break
      }
    },

    async turnOnEditMode (uuid) {
      this.editMode = true
      this.editedText = this.val.message.text[this.$store.state.flowEditorLocale]
      await this.delayMs(10)
      this.$refs.textarea.$el.focus()
    },

    turnOffEditMode (uuid) {
      this.val.message.text[this.$store.state.flowEditorLocale] = this.editedText
      this.editMode = false
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-message {
  @include flowElementShadow();
  width: 23%;
  min-width: 280px;
  background-color: white;
  border-radius: 7px;
  align-self: center;

  &__glow {
    border-bottom: none;
    border-radius: 7px 7px 0 0;
    border-color: $primary;
    box-shadow: 0 0 12px $primary;
  }

  &__text {
    text-align: left;
    padding: 12px 15px 15px 15px;
    cursor: text;
    overflow-wrap: break-word;
    white-space: pre-line;
  }

  &__create-button {
    @include alignedFlex();
    height: 30px;
    border-top: 1px solid $borderGrey;
    transition: background-color 0.2s ease;
    border-radius: 0 0 7px 7px;
    background-color: white;
    color: $danger;
    font-size: 0.9em;
    cursor: pointer;

    &:hover {
      background-color: $messageHover;
    }
  }

  &__textarea {
    width: calc(100% - 30px);
    padding: 12px 15px 0 15px;
    font-size: 1em;
    font-family: "Lato";
    border: none;
    border-radius: 7px 7px 0 0;
    outline: none !important;
  }
}
</style>
